/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  const cartQuickViewLinks = document.querySelectorAll('.vd-link');
  if (cartQuickViewLinks.length) {
    cartQuickViewLinks.forEach((link) => {
      const handleEvent = (e) => {
        e.preventDefault(); // Prevent default action (e.g., following a link)
        let productId = link.dataset.productId;
        let quickViewEl = document.querySelector(`.cart-item-popup-indv-${productId}`);
        if (quickViewEl) {
          quickViewEl.classList.add('active');
        }
      };
  
      link.addEventListener('click', handleEvent);
      link.addEventListener('touchstart', handleEvent); // Handle touch events for better iOS support
    });
  }
	



  // Collection cards: line up each row of the grid (desktop and mobile).
  // A  Every title in a row gets the height of the tallest title (extra space under the shorter ones,
  //    as padding on the title), so the pills below start at the same height on every card whether the
  //    name takes 1, 2 or 3 lines.
  // B  Cards that have an offer line (snippets/skin-sale-pill.liquid) but no USP pill are pushed down so
  //    their offer line sits level with the offer lines of the cards that do have a USP pill.
  // C  Whatever height difference is left goes under the card's last pill row (--sale-slack for the offer
  //    line, --usp-slack for the USP pill) or, with no pills, under the title, so the prices line up.
  // Everything is measured from where the elements actually sit, in three passes (all reads, then all
  // writes) so the page is not re-laid-out card by card.
  (function () {
    var grids = document.querySelectorAll('.template-collection #CollectionLoop');
    if (!grids.length) return;

    var PRICE = '.product-item__price__holder, .product-item__price';

    function offset(card, el) {
      return el ? el.getBoundingClientRect().top - card.getBoundingClientRect().top : null;
    }

    function addPad(item, extra) {
      if (extra > 0.05) {
        item.pad += extra;
        item.title.style.paddingBottom = item.pad + 'px';
      }
    }

    function syncGrid(grid) {
      var cards = Array.prototype.filter.call(grid.children, function (el) {
        return el.classList.contains('product-item') && el.offsetParent !== null && el.querySelector('.product-item__title');
      });

      // Clean slate so every measurement is the card's natural layout.
      cards.forEach(function (card) {
        card.style.removeProperty('--title-slack');
        card.style.removeProperty('--usp-slack');
        card.style.removeProperty('--sale-slack');
        card.querySelector('.product-item__title').style.paddingBottom = '';
      });

      var rows = [];
      cards.forEach(function (card) {
        var top = Math.round(card.getBoundingClientRect().top + window.pageYOffset);
        var row = rows.length ? rows[rows.length - 1] : null;
        if (!row || Math.abs(row.top - top) > 2) {
          row = { top: top, items: [] };
          rows.push(row);
        }
        row.items.push({
          card: card,
          title: card.querySelector('.product-item__title'),
          pill: card.querySelector('.product-item__usp'),
          sale: card.querySelector('.sale33'),
          pad: 0
        });
      });

      // A: title heights
      rows.forEach(function (row) {
        row.items.forEach(function (item) { item.titleHeight = item.title.getBoundingClientRect().height; });
        row.tallestTitle = row.items.reduce(function (max, item) { return Math.max(max, item.titleHeight); }, 0);
      });
      rows.forEach(function (row) {
        row.items.forEach(function (item) { addPad(item, row.tallestTitle - item.titleHeight); });
      });

      // B: offer lines of cards without a USP pill follow the offer lines of the rest of the row
      rows.forEach(function (row) {
        row.saleTop = 0;
        row.items.forEach(function (item) {
          item.saleTop = item.sale ? offset(item.card, item.sale) : null;
          if (item.saleTop !== null) row.saleTop = Math.max(row.saleTop, item.saleTop);
        });
      });
      rows.forEach(function (row) {
        row.items.forEach(function (item) {
          if (item.saleTop !== null) addPad(item, row.saleTop - item.saleTop);
        });
      });

      // C: prices
      rows.forEach(function (row) {
        row.priceTop = 0;
        row.items.forEach(function (item) {
          item.priceTop = offset(item.card, item.card.querySelector(PRICE));
          if (item.priceTop !== null) row.priceTop = Math.max(row.priceTop, item.priceTop);
        });
      });
      rows.forEach(function (row) {
        row.items.forEach(function (item) {
          if (item.priceTop === null) return;
          var lag = row.priceTop - item.priceTop;
          if (lag <= 0.05) return;
          if (item.sale) item.card.style.setProperty('--sale-slack', lag + 'px');
          else if (item.pill) item.card.style.setProperty('--usp-slack', lag + 'px');
          else addPad(item, lag);
        });
      });
    }

    var queued = false;
    function syncAll() {
      if (queued) return;
      queued = true;
      // A short timer rather than requestAnimationFrame: rAF is paused in background tabs and
      // some embedded webviews, which would leave the row sizing unapplied.
      window.setTimeout(function () {
        queued = false;
        grids.forEach(syncGrid);
      }, 30);
    }

    syncAll();
    window.addEventListener('load', syncAll);
    window.addEventListener('resize', syncAll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAll);
    // Filtering, sorting and "load more" re-render the grid's cards.
    grids.forEach(function (grid) {
      new MutationObserver(syncAll).observe(grid, { childList: true });
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
